/**
 * @generated SignedSource<<614828c738cbf3002e4a452e9ead3011>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRecentSales_itemSearch$data = {
  readonly pageType: string | null;
  readonly soldItemResults: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_item">;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_itemSearch">;
  readonly " $fragmentType": "SharedRecentSales_itemSearch";
};
export type SharedRecentSales_itemSearch$key = {
  readonly " $data"?: SharedRecentSales_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRecentSales_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRecentSales_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_itemSearch"
    },
    {
      "alias": "soldItemResults",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 28
        }
      ],
      "concreteType": "soldResultsConnection",
      "kind": "LinkedField",
      "name": "soldResults",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "soldResultsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSearchResult",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SharedRelatedItemsSection_item"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "soldResults(first:28)"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "d4486de4b494e7fcd0ee96e3e968814b";

export default node;
